// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5336": "5083bc5218c4","643": "c13b59ec9688","6863": "454c9f289029","6870": "b7a81b08c239","8357": "dd422574e14d",}[chunkId] + ".css"
}